import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withCookieConsent } from 'LiveBoard/hocs'
import { closePrivacyWarning } from 'LiveBoard/modules/cookiesConsent'
import {
  PrivacyWarningBase, PrivacyWarningInjector
} from 'LiveBoard/components/shared/PrivacyWarning'
import cookieManagementTypes from 'common/constants/cookieManagementTypes'
import get from 'lodash/get'

const PrivacyWarningContainer = (props) => {

  const handleClose = () => {
    props.onCookieConsent()
    props.closePrivacyWarning()
  }

  const PrivacyMessageComponent = props.privacyMessageComponent
  // cookie management value can be null/internal/external - null is same as internal
  const isInternalCookieManagement = props.boardCookieManagement != cookieManagementTypes.external

  return (props.privacyMessageComponent &&
    isInternalCookieManagement &&
    <PrivacyMessageComponent
      isOpen={props.isOpen}
      { ...props.privacyMessageMetadata}
      onClose={handleClose} />
  )
}

PrivacyWarningContainer.propTypes = {
  privacyMessageMetadata: PropTypes.object.isRequired,
  privacyMessageComponent: PropTypes.func,
  isOpen: PropTypes.bool.isRequired
}

function mapStateToProps({ board, cookiesConsent }) {
  return {
    boardCookieManagement: get(board.privacy, 'cookie_management'),
    isOpen: cookiesConsent.isPrivacyWarningOpen,
    privacyMessageMetadata: cookiesConsent.privacyMessageMetadata,
    privacyMessageComponent: cookiesConsent.privacyMessageComponent
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ closePrivacyWarning }, dispatch)
}

export default connect(
  mapStateToProps, mapDispatchToProps
)(withCookieConsent(PrivacyWarningContainer))